import script from "./TheRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./TheRegister.vue?vue&type=script&setup=true&lang=js"

import "./TheRegister.vue?vue&type=style&index=0&id=34b5b04e&lang=css"

const __exports__ = script;

export default __exports__